import { queryOptions } from "@tanstack/react-query";
import { projectKeys } from "$/modules/projects/lib/queries";
import { getAllQuestions } from "./question";

export const questionsQueryOptions = (
	userId: string,
	projectId: string,
	questionnaireId: string,
) =>
	queryOptions({
		queryKey: [
			...projectKeys.project(userId, projectId),
			"questions",
			questionnaireId,
		],
		queryFn: () => getAllQuestions({ questionnaireId }),
	});
